import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HpcConfig } from '../../../../../../core/models/node-config';
import { NodeConfigService } from '../../../../../../core/services/node-config.service';
import { DeploymentService } from 'src/app/core/services/deployment.service';

@Component({
  selector: 'app-update-node-configurator',
  templateUrl: './update-node-configurator.component.html',
  styleUrls: ['./update-node-configurator.component.scss']
})
export class UpdateNodeConfiguratorComponent implements OnInit {

  constructor(
    public dialog: MatDialogRef<UpdateNodeConfiguratorComponent>,
    public nodeConfigService: NodeConfigService,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA)
    public data: { nodeConfig: HpcConfig }, private depService: DeploymentService
  ) { }

  depName: any;
  cloudProviderName: any;
  cloudProviders: any[];
  isLinear = false;

  cpuDetails: UntypedFormGroup;
  diskDetails: UntypedFormGroup;
  cloudInfraDetails: UntypedFormGroup;
  soketsAndCoreDetails: UntypedFormGroup;
  gpuDetails: UntypedFormGroup;
  rdmaDetails: UntypedFormGroup;
  instanceCode = this.data?.nodeConfig?.instanceCode;

  ngOnInit(): void {
    this.depService.getAllCloudProvidersValueText().subscribe({
      next: (data: any) => {
        if (data) {
          this.cloudProviders = data;
        }
        },
      error: (error) => {
        this.snackBar.open("Failed to fetch cloud provider list, please try again.", "Ok", { duration: 5000 });
        }
    });
    this.cpuDetails = new UntypedFormGroup({
      instanceCode: new UntypedFormControl(this.data.nodeConfig.instanceCode, [Validators.required]),
      cpuCores: new UntypedFormControl(this.data.nodeConfig.hpcUnits, [Validators.required, Validators.pattern("^[0-9]*$")]),
      hpcUnits: new UntypedFormControl(this.data.nodeConfig.cpuCores, [Validators.required, Validators.pattern("^[0-9]*$")]),
      cpuType: new UntypedFormControl(this.data.nodeConfig.cpuType, [Validators.required]),
      numofSockets: new UntypedFormControl(this.data.nodeConfig.numOfSockets, [Validators.required, Validators.pattern("^[0-9]*$")]),
      coresPerSocket: new UntypedFormControl(this.data.nodeConfig.coresPerSocket, [Validators.required, Validators.pattern("^[0-9]*$")]),
      threadsPerCore: new UntypedFormControl(this.data.nodeConfig.threadsPerCore, [Validators.required, Validators.pattern("^[0-9]*$")]),
    })

    this.diskDetails = new UntypedFormGroup({
      storageSize: new UntypedFormControl(this.data.nodeConfig.hddSize, [Validators.required, Validators.pattern("^[0-9]*$")]),
      RAMSize: new UntypedFormControl(this.data.nodeConfig.ramSize, [Validators.required, Validators.pattern("^[0-9]*$")]),
      storageType: new UntypedFormControl(this.data.nodeConfig.hddType, [Validators.required]),
    })

    this.cloudInfraDetails = new UntypedFormGroup({
      cloudType: new UntypedFormControl(this.data.nodeConfig.cloudProvider, [Validators.required]),
    })

    this.soketsAndCoreDetails = new UntypedFormGroup({
    })

    this.gpuDetails = new UntypedFormGroup({
      noOfGpu: new UntypedFormControl(this.data.nodeConfig.noOfGPU, [Validators.required, Validators.pattern("^[0-9]*$")]),
      gpuMemorySize: new UntypedFormControl(this.data.nodeConfig.gpuMemorySize, [Validators.required, Validators.pattern("^[0-9]*$")]),
      gpuModel: new UntypedFormControl(this.data.nodeConfig.gpuModel, [Validators.required]),
    })

    this.rdmaDetails = new UntypedFormGroup({
      isRDMAsupport: new UntypedFormControl(this.data.nodeConfig.isRdmaSupported.toString(), [Validators.required]),
    })
  }

  onClose() {
    this.dialog.close(false)
  }

  onSubmit(cpuDetails: UntypedFormGroup, diskDetails: UntypedFormGroup, cloudInfraDetails: UntypedFormGroup,
    soketsAndCoreDetails: UntypedFormGroup, gpuDetails: UntypedFormGroup, rdmaDetails: UntypedFormGroup) {

    if (!cpuDetails.valid) {
      this.cpuDetails.markAllAsTouched();
      return;
    }
    if (!diskDetails.valid) {
      this.diskDetails.markAllAsTouched();
      return;
    }
    if (!cloudInfraDetails.valid) {
      this.cloudInfraDetails.markAllAsTouched();
      return;
    }
    if (!gpuDetails.valid) {
      this.gpuDetails.markAllAsTouched();
      return;
    }
    if (!rdmaDetails.valid) {
      this.rdmaDetails.markAllAsTouched();
      return;
    }
    let nodeConfig: HpcConfig = {
      hpcConfigId: this.data.nodeConfig.hpcConfigId,
      cpuCores: cpuDetails.value.cpuCores,
      cpuType: cpuDetails.value.cpuType,
      hpcUnits: cpuDetails.value.hpcUnits,
      cloudProvider: cloudInfraDetails.value.cloudType,
      ramSize: diskDetails.value.RAMSize,
      hddType: diskDetails.value.storageType,
      hddSize: diskDetails.value.storageSize,
      isRdmaSupported: JSON.parse(rdmaDetails.value.isRDMAsupport),
      numOfSockets: cpuDetails.value.numofSockets,
      coresPerSocket: cpuDetails.value.coresPerSocket,
      threadsPerCore: cpuDetails.value.threadsPerCore,
      instanceCode: cpuDetails.value.instanceCode,
      maxHpcNodes: 0,
      pricePerHour: 0,
      description: null,
      noOfGPU: gpuDetails.value.noOfGpu,
      gpuMemorySize: gpuDetails.value.gpuMemorySize,
      gpuModel: gpuDetails.value.gpuModel,
      cpuModel: null,
    }
    
    this.nodeConfigService.updateNodeConfig(nodeConfig)
      .subscribe({
        next: (data) => {
          this.snackBar.open(data.message, "Ok", {
            duration: 5000
          });
          this.dialog.close(true)
        }, error: (err) => {
          this.dialog.close(true)
        }
      })
  }
}
